import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Box, Typography, Tab, Button, Grid, Skeleton, } from '@mui/material';
import { useStore, useTokens, } from '@mcn-platform/models';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import VerticalMediaCard from '../item/card/VerticalMediaCard';
import { getMeetingRegistrationStatusFilter } from './meetingHelpers';
import AccountDialogs from '../nav/AccountDialogs';
const ItemList = observer(({ registrationList }) => {
    console.log('registrationList', registrationList);
    if (registrationList?.items?.length === 0 && registrationList?.syncState === 'loaded') {
        return (_jsx(Box, { sx: { textAlign: 'center' }, children: _jsx(Typography, { variant: "h5", color: "text.primary", children: "No meetings found." }) }));
    }
    // loading
    if (registrationList?.syncState !== 'loaded') {
        return (_jsx(Grid, { container: true, spacing: 2, alignContent: "center", justifyContent: "left", children: [...Array(4)].map((e) => (_jsx(Grid, { item: true, xs: 12, sm: 6, md: 4, lg: 3, xl: 2, sx: {
                    minWidth: '275px',
                }, children: _jsx(Skeleton, { variant: "rectangular", width: "100%", height: "285px" }) }, e))) }));
    }
    return (_jsx(Grid, { container: true, spacing: 2, alignContent: "center", justifyContent: "left", children: (registrationList.items).map((registration) => {
            if (registration?.meeting?.syncState === 'loaded') {
                return (_jsx(Grid, { item: true, xs: 12, sm: 6, md: 4, lg: 3, xl: 2, sx: {
                        minWidth: '275px',
                    }, children: _jsx(VerticalMediaCard, { item: registration.meeting, size: "large" }) }, registration.key));
            }
            return null;
        }) }));
});
// eslint-1disable-next-line @typescript-eslint/no-unused-vars
const MyMeetings = ({ limitToPageWidth = true, }) => {
    const { currentPortal, currentCustomer, getCachedList, isAnonymous, } = useStore();
    const tokens = useTokens();
    const [tabValue, setTabValue] = useState('upcoming');
    const [registrationList, setRegistrationList] = useState();
    const tabs = [
        { id: 'upcoming', text: 'Upcoming' },
        { id: 'past', text: 'Past' },
    ];
    const getTabs = () => (tabs);
    const handleChange = (event, newValue) => {
        setTabValue(newValue);
    };
    useEffect(() => {
        if (!currentCustomer?.id) {
            return;
        }
        const registrationStatusOr = getMeetingRegistrationStatusFilter(tabValue);
        const newList = getCachedList('meetingRegistration', {
            portalID: { eq: currentPortal.id },
            customerID: { eq: currentCustomer.id },
            ...registrationStatusOr,
        });
        newList.setRequestedCount(1000);
        setRegistrationList(newList);
    }, [
        currentCustomer?.id,
        currentPortal?.id,
        getCachedList,
        tabValue,
        // registrationList?.syncState,
    ]);
    const [showDialog, setShowDialog] = useState();
    if (isAnonymous) {
        return (_jsxs(Box, { sx: {
                m: 2,
                px: 4,
                ...(limitToPageWidth && {
                    width: '100%',
                    maxWidth: 1200,
                    marginX: 'auto',
                }),
            }, children: [_jsxs(Typography, { variant: "h4", children: ["To get access to", ' ', tokens.getToken('myMeetingsLabel'), ", please either", _jsx(Button, { onClick: () => setShowDialog('SIGN-IN'), sx: { textTransform: 'none', fontSize: 'inherit', verticalAlign: 'baseline' }, children: "sign in" }), "or", _jsx(Button, { onClick: () => setShowDialog('SIGN-UP'), sx: { textTransform: 'none', fontSize: 'inherit', verticalAlign: 'baseline' }, children: "create an account." })] }), _jsx(AccountDialogs, { showDialog: showDialog, setShowDialog: setShowDialog, handleClose: () => setShowDialog(undefined) })] }));
    }
    return (_jsxs(Box, { sx: {
            m: 2,
            px: 4,
            ...(limitToPageWidth && {
                width: '100%',
                maxWidth: 1200,
                marginX: 'auto',
            }),
        }, children: [_jsx(Typography, { className: "systemPageTitle", children: tokens.getToken('myMeetingsLabel') }), _jsx(Box, { sx: { width: '100%', typography: 'body1' }, children: _jsxs(TabContext, { value: tabValue, children: [_jsx(TabList, { onChange: handleChange, "aria-label": "tabs", textColor: "inherit", children: getTabs().map((tab) => (_jsx(Tab, { value: tab.id, label: tab.text, sx: {
                                    borderBottom: 0,
                                    p: 0,
                                    mx: 2,
                                    my: 1.5,
                                    minWidth: '50px',
                                    minHeight: '25px',
                                    '&.Mui-selected': {
                                        borderBottom: 1,
                                        borderColor: 'contract.main',
                                    },
                                } }, tab.id))) }), _jsx(ItemList, { registrationList: registrationList })] }) })] }));
};
MyMeetings.defaultProps = {};
MyMeetings.meta = {
    group: 'account',
    name: 'My Meetings',
    description: 'Shows information about the current users meetings',
    props: [
        {
            key: 'limitToPageWidth',
            name: 'Limit Width',
            type: 'boolean',
            description: 'Limit the width of the stack to the maximum page width',
            group: 'style',
        },
    ],
    defaultConfig: {
        type: 'component',
        component: 'MyMeetings',
        props: {
            limitToPageWidth: true,
        },
    },
};
export default observer(MyMeetings);
//# sourceMappingURL=MyMeetings.js.map